export default __webpack_public_path__ + "static/media/yakuza.de965ce9.png";